import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Alert } from "@mui/material"; // Ensure the alert component is imported
import Cookie from "cookie-universal";
import { SOCIALLINKS } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";

function SocialLinks() {
  const [platform, setPlatform] = useState("");
  const [link, setLink] = useState("");
  const [alert, setAlert] = useState(null);

  const token = Cookie().get("dashboardLogin");
  const userRole = Cookie().get("userRole");
  const data = {
    platform: platform, // Ensure this is filled out
    url: link, // Ensure this is filled out
  };

  const fetchSocialLinks = async () => {
    try {
      const response = await Axios.get(`/panel/${SOCIALLINKS}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });
      console.log("Fetched social links:", response.data);
      setPlatform(response.data);
      setLink(response.data);
      // You can update state here or do any other handling you need
    } catch (error) {
      console.error("Error fetching social links:", error);
    }
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();

    try {
      const response = await Axios.post(`/panel/${SOCIALLINKS}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });
      // Fetch updated social links after successful creation
      fetchSocialLinks();

      // Reset form fields
      setPlatform("");
      setLink("");
      setAlert({ type: "success", message: "Social link added successfully!" });
    } catch (error) {
      console.error("Error adding social link:", error);
      if (error.response) {
        setAlert({
          type: "error",
          message:
            error.response.data.message || "Failed to add the social link.",
        });
      } else {
        setAlert({ type: "error", message: "Network or server error." });
      }
    }
  };

  return (
    <>
      {alert && <Alert severity={alert.type}>{alert.message}</Alert>}

      <Grid size={12}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Platform</Form.Label>
            <Form.Control
              type="text"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              placeholder="Enter Platform"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Link</Form.Label>
            <Form.Control
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="Enter Link"
            />
          </Form.Group>

          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Grid>
    </>
  );
}

export default SocialLinks;
